import { Component, inject, Input, OnInit } from '@angular/core';
import { Goal2030Model, OutcomeMetricModel, ProjectLinkedOutcomeModel, ProjectModel } from '../../../../../hub_schema/hubTypes';
import { HubLovService } from 'src/app/core/services/hub-lov.service';
import { take } from 'rxjs';

@Component({
    selector: 'app-program-linked-outcomes-panel',
    templateUrl: './program-linked-outcomes-panel.component.html',
    styleUrl: './program-linked-outcomes-panel.component.scss',
    standalone: false
})
export class ProgramLinkedOutcomesPanelComponent implements OnInit {
    private hubLovService: HubLovService = inject(HubLovService);
    public goals: Goal2030Model[] | undefined;
    public outcomeMetrics: OutcomeMetricModel[] | undefined;

    @Input()
    public project!: ProjectModel;

    public ngOnInit(): void {
        this.hubLovService
            .get2030Goals()
            .pipe(take(1))
            .subscribe((goals: Goal2030Model[]) => {
                this.goals = goals;
            });
        this.hubLovService
            .getOutcomeMetrics()
            .pipe(take(1))
            .subscribe((metrics: OutcomeMetricModel[]) => {
                this.outcomeMetrics = metrics;
            });
    }

    public get linkedOutcomes(): ProjectLinkedOutcomeModel[] {
        if (this.project) {
            return this.project.linkedOutcomes!;
        }
        return [];
    }

    public hasProjectGoalTarget(goalId: number): boolean {
        var result;
        result = this.project.projectGoalTargets.some(pgt => pgt.goalId === goalId);
        return result;
    }

    public hasProjectOutcomeMetric(goalId: number) {
        var result;

        result = this.project.projectOutcomeMetricTargets.some(pomt =>
            this.outcomeMetrics.some(om => om.outcomeMetricId === pomt.outcomeMetricId && om.goal2030Id === goalId)
        );
        return result;
    }

    public GetLinkedOutcomesByGoal(goalId: number) {
        let linkedOutcomeByGoal = [];
        if (this?.project?.linkedOutcomes) {
            linkedOutcomeByGoal = this.project.linkedOutcomes.filter(lo => lo.projectOutcome?.outcome?.outcomeMetric?.goal2030Id === goalId);
        }
        return linkedOutcomeByGoal;
    }
}
